<template>
  <Attachments
    :label="$lang.attachments"
    :isDisabledAddButton="isReadonly"
    uploaderName="center_execute_case"
    resourceName="person_content"
    :getListMethod="handleGetAttachments"
    :createMethod="handleCreateAttachment"
    :updateMethod="handleUpdateAttachment"
    :deleteMethod="handleDeleteAttachment"
  />
</template>
<script>
import { Attachments } from "@/components/re-design";
import {
  getAttachments,
  createAttachment,
  updateAttachment,
  deleteAttachment,
} from "@/modules/kanoon/services";
import { generateError } from "@/shared/utils";
import { inject } from "vue";
export default {
  components: { Attachments },
  props: {
    isReadonly: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const caseId = inject("CASE_ID");
    const handleGetAttachments = async (page, perPage) => {
      try {
        const response = await getAttachments(caseId.value, page, perPage);
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleCreateAttachment = async (tempFiles) => {
      try {
        const response = await createAttachment(caseId.value, tempFiles);
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleUpdateAttachment = async (
      attachmentCode,
      attachmentTypeId,
      attachmentCaption
    ) => {
      try {
        const response = await updateAttachment({
          caseId: caseId.value,
          attachmentCode,
          attachmentTypeId,
          attachmentCaption,
        });
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleDeleteAttachment = async (attachmentCode) => {
      try {
        const response = await deleteAttachment(caseId.value, attachmentCode);
        return response;
      } catch (error) {
        generateError(error);
      }
    };

    // return data to be used in template
    return {
      handleGetAttachments,
      handleCreateAttachment,
      handleUpdateAttachment,
      handleDeleteAttachment,
    };
  },
};
</script>
